/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { ScenarioChatFormQueryFragmentDoc } from '../../components/organisms/ScenarioChatForm/ScenarioChatForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CreateScenarioChatInput = {
  messages: Array<ScenarioChatMessageInput>;
  title: string;
};

export type ScenarioChatMessageBasicSelectionInput = {
  actions: Array<ScenarioChatMessageSelectionActionInput>;
  guid?: string | number | null | undefined;
  label: string;
  nextMessageIndex?: number | null | undefined;
};

export type ScenarioChatMessageBookingRequestSelectionsInput = {
  fallbackUrl?: string | null | undefined;
  guid?: string | number | null | undefined;
};

export type ScenarioChatMessageInput = {
  body: string;
  guid?: string | number | null | undefined;
  selections: Array<ScenarioChatMessageSelectionInput>;
  selectionsV2?: ScenarioChatMessageSelectionsInput | null | undefined;
};

export type ScenarioChatMessageSelectionActionInput = {
  /** oneof */
  assignPlannerAccountToMatch?: ScrnarioChatMessageSelectionActionAssignPlannerAccountToMatchInput | null | undefined;
};

export type ScenarioChatMessageSelectionInput = {
  actions: Array<ScenarioChatMessageSelectionActionInput>;
  guid?: string | number | null | undefined;
  label: string;
  nextMessageIndex?: number | null | undefined;
};

export type ScenarioChatMessageSelectionsInput = {
  /** oneof */
  basicSelections?: Array<ScenarioChatMessageBasicSelectionInput> | null | undefined;
  bookingRequestSelections?: ScenarioChatMessageBookingRequestSelectionsInput | null | undefined;
};

export type ScrnarioChatMessageSelectionActionAssignPlannerAccountToMatchInput = {
  assignedPlannerAccountId?: string | number | null | undefined;
  assignedStaffGUID: string | number;
  guid?: string | number | null | undefined;
};

export type ScenarioChatNewPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ScenarioChatNewPageQuery = { staffsByPlanner: Array<{ guid: string, displayName: string }> };

export type CreateScenarioChatMutationVariables = Exact<{
  input: Types.CreateScenarioChatInput;
}>;


export type CreateScenarioChatMutation = { createScenarioChat: { guid: string } };


export const ScenarioChatNewPageDocument = gql`
    query ScenarioChatNewPage {
  ...ScenarioChatFormQuery
}
    ${ScenarioChatFormQueryFragmentDoc}`;

/**
 * __useScenarioChatNewPageQuery__
 *
 * To run a query within a Vue component, call `useScenarioChatNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioChatNewPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useScenarioChatNewPageQuery();
 */
export function useScenarioChatNewPageQuery(options: VueApolloComposable.UseQueryOptions<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables>(ScenarioChatNewPageDocument, {}, options);
}
export function useScenarioChatNewPageLazyQuery(options: VueApolloComposable.UseQueryOptions<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables>(ScenarioChatNewPageDocument, {}, options);
}
export type ScenarioChatNewPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ScenarioChatNewPageQuery, ScenarioChatNewPageQueryVariables>;
export const CreateScenarioChatDocument = gql`
    mutation CreateScenarioChat($input: CreateScenarioChatInput!) {
  createScenarioChat(input: $input) {
    guid
  }
}
    `;

/**
 * __useCreateScenarioChatMutation__
 *
 * To run a mutation, you first call `useCreateScenarioChatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateScenarioChatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateScenarioChatMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateScenarioChatMutation(options: VueApolloComposable.UseMutationOptions<CreateScenarioChatMutation, CreateScenarioChatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateScenarioChatMutation, CreateScenarioChatMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateScenarioChatMutation, CreateScenarioChatMutationVariables>(CreateScenarioChatDocument, options);
}
export type CreateScenarioChatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateScenarioChatMutation, CreateScenarioChatMutationVariables>;